import React from 'react';
import { TrophyIcon, StarIcon, BarChart3Icon, HeartIcon, LayersIcon } from 'lucide-react';
export const GameMechanicsSlide = () => {
  return <div className="p-8 md:p-16 min-h-[600px] bg-white" data-id="element-186">
      <h2 className="text-2xl md:text-3xl font-light text-[#333333] mb-5 border-l-4 border-[#d4af37] pl-4" data-id="element-187">
        Verfijnde Gamification-Mechanismen
      </h2>
      <div className="flex items-center mb-5" data-id="element-188">
        <TrophyIcon className="w-5 h-5 text-[#d4af37] mr-3" data-id="element-189" />
        <p className="text-[#666666] text-sm leading-relaxed" data-id="element-190">
          Mosy gebruikt zorgvuldig ontworpen gamification-mechanismen die passen
          bij een premium mentale gezondheidsapp.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5" data-id="element-191">
        <div className="bg-[#f7f3ef] p-4 rounded-lg shadow-sm transition-all hover:shadow-md" data-id="element-192">
          <h3 className="text-xl font-light text-[#333333] mb-3 flex items-center" data-id="element-193">
            <StarIcon className="w-5 h-5 text-[#d4af37] mr-2" data-id="element-194" />
            Kernelementen
          </h3>
          <div className="space-y-3 mb-3" data-id="element-195">
            <div className="flex items-start" data-id="element-196">
              <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center mr-3 mt-1" data-id="element-197">
                <div className="w-4 h-4 rounded-full bg-[#d4af37]" data-id="element-198"></div>
              </div>
              <div data-id="element-199">
                <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-200">
                  Balansreeksen
                </p>
                <p className="text-xs text-[#666666] leading-relaxed" data-id="element-201">
                  Consistente check-ins bouwen "balansreeksen" op, vergelijkbaar
                  met streaks maar met een therapeutische framing.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-202">
              <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center mr-3 mt-1" data-id="element-203">
                <div className="w-4 h-4 rounded-full bg-[#d4af37]" data-id="element-204"></div>
              </div>
              <div data-id="element-205">
                <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-206">
                  Voortgangspaden
                </p>
                <p className="text-xs text-[#666666] leading-relaxed" data-id="element-207">
                  Visuele representatie van de gebruikersreis door verschillende
                  thema's, met mijlpalen en ontgrendelbare content.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-208">
              <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center mr-3 mt-1" data-id="element-209">
                <div className="w-4 h-4 rounded-full bg-[#d4af37]" data-id="element-210"></div>
              </div>
              <div data-id="element-211">
                <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-212">
                  Collecties & Verzamelingen
                </p>
                <p className="text-xs text-[#666666] leading-relaxed" data-id="element-213">
                  Gebruikers "verzamelen" oefeningen, inzichten en tools die ze
                  hebben vrijgespeeld, wat een gevoel van eigendom creëert.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-[#f7f3ef] p-4 rounded-lg shadow-sm transition-all hover:shadow-md" data-id="element-214">
          <h3 className="text-xl font-light text-[#333333] mb-3 flex items-center" data-id="element-215">
            <BarChart3Icon className="w-5 h-5 text-[#d4af37] mr-2" data-id="element-216" />
            Niveausysteem
          </h3>
          <div className="space-y-3 mb-3" data-id="element-217">
            <div className="flex items-start" data-id="element-218">
              <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center mr-3 mt-1" data-id="element-219">
                <HeartIcon className="w-4 h-4 text-[#d4af37]" data-id="element-220" />
              </div>
              <div data-id="element-221">
                <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-222">
                  Inzichtniveaus
                </p>
                <p className="text-xs text-[#666666] leading-relaxed" data-id="element-223">
                  In plaats van traditionele "levels" stijgen gebruikers in
                  "inzichtniveaus" binnen elk thema, met nieuwe content en
                  functies.
                </p>
              </div>
            </div>
            <div className="bg-white p-3 rounded-lg mb-3" data-id="element-224">
              <div className="flex items-center justify-between mb-2" data-id="element-225">
                <p className="text-xs font-medium text-[#666666]" data-id="element-226">
                  Stressreductie: Inzichtniveau 2
                </p>
                <p className="text-xs text-[#d4af37]" data-id="element-227">70%</p>
              </div>
              <div className="w-full h-1.5 bg-[#f7f3ef] rounded-full" data-id="element-228">
                <div className="h-full w-[70%] bg-[#d4af37] rounded-full" data-id="element-229"></div>
              </div>
              <div className="mt-2 flex justify-between" data-id="element-230">
                <p className="text-xs text-[#888888]" data-id="element-231">7/10 check-ins</p>
                <p className="text-xs text-[#888888]" data-id="element-232">
                  Volgende: Geavanceerde technieken
                </p>
              </div>
            </div>
          </div>
          <div className="flex justify-between items-center bg-white p-3 rounded-lg" data-id="element-233">
            <div className="flex items-center" data-id="element-234">
              <div className="w-7 h-7 rounded-full bg-[#f7f3ef] flex items-center justify-center mr-2" data-id="element-235">
                <TrophyIcon className="w-3.5 h-3.5 text-[#d4af37]" data-id="element-236" />
              </div>
              <div data-id="element-237">
                <p className="text-xs font-medium text-[#666666]" data-id="element-238">
                  Balansmeester
                </p>
                <p className="text-xs text-[#888888]" data-id="element-239">
                  Bereik inzichtniveau 3 in twee thema's
                </p>
              </div>
            </div>
            <div className="text-xs text-[#d4af37]" data-id="element-240">50%</div>
          </div>
        </div>
      </div>
      <div className="bg-[#f7f3ef] p-4 rounded-lg" data-id="element-241">
        <h3 className="text-lg font-light text-[#333333] mb-3 flex items-center justify-center" data-id="element-242">
          <LayersIcon className="w-5 h-5 text-[#d4af37] mr-2" data-id="element-243" />
          Nieuwe Gamification-Innovaties
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-244">
          <div className="bg-white p-3 rounded-lg" data-id="element-245">
            <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-246">
              Adaptieve Uitdagingen
            </p>
            <p className="text-xs text-[#666666]" data-id="element-247">
              Uitdagingen die zich aanpassen aan de vooruitgang en capaciteiten
              van de gebruiker
            </p>
          </div>
          <div className="bg-white p-3 rounded-lg" data-id="element-248">
            <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-249">
              Micro-Doelen
            </p>
            <p className="text-xs text-[#666666]" data-id="element-250">
              Kleine, haalbare doelen die leiden tot onmiddellijke beloningen en
              snelle voortgang
            </p>
          </div>
          <div className="bg-white p-3 rounded-lg" data-id="element-251">
            <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-252">
              Thematische Reizen
            </p>
            <p className="text-xs text-[#666666]" data-id="element-253">
              Gepersonaliseerde reis door verschillende mentale
              gezondheidsthema's
            </p>
          </div>
        </div>
      </div>
    </div>;
};